/**
 * Utility function to execute a function and capture any errors.
 * @param func
 * @returns
 */
export function withError<T>(
  func: () => T,
): { err: Error; result: null } | { err: null; result: T } {
  try {
    const result = func();
    return { err: null, result };
  } catch (err) {
    return { err, result: null };
  }
}

/**
 * An error that has context property
 */
export class ContextError<T extends object> extends Error {
  constructor(
    message: string,
    public context?: T,
  ) {
    super(message);
    this.name = 'ContextError';
  }
}
